import React, { PropTypes } from 'react'
import classNames from 'classnames'

const ControlledTextInput = ({ id, value, onChange, onBlur, maxLength, className, ...rest }) => (
  <input id={id || ''} type="text" maxLength={maxLength || ''} value={value || ''}
    className={classNames(['controlled-text-input', className])}
    onChange={(evt) => { onChange(evt.target.value) }}
	onBlur={(evt) => { onBlur(evt.target.value) }}
    {...rest}
  />
)

ControlledTextInput.propTypes = {
  id : PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number // this added bc of the insurance field in confirm
  ]),
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
}

export default ControlledTextInput;